// extracted by mini-css-extract-plugin
export default {"main_container_inner":"recheck_main_container_inner__sz+a+","main_container":"recheck_main_container__Nb1cL","print":"recheck_print__iEi+4"};